import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1" });

export const ProjectService = {
  getProjectList: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/projects?${params.toString()}`);
  },

  createProject: (projectDetails) => api.post("/projects", projectDetails),

  getProjectById: (projectId) => api.get(`/projects/${projectId}`),

  updateProject: (projectId, projectDetails) => api.patch(`/projects/${projectId}`, projectDetails),

  deleteProject: (projectId) => api.delete(`/projects/${projectId}`),

  createStage: (stageData) => api.post("/stages", stageData),
  getStages: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/stages?${params.toString()}`);
  },

  getStageById: (stageId) => api.get(`/stages/${stageId}`),

  updateStage: (stageId, stageData) => api.patch(`/stages/${stageId}`, stageData),

  deleteStage: (stageId) => api.delete(`/stages/${stageId}`),

  createProjectStage: (projectStageData) => api.post("/project-stages", projectStageData),

  getProjectStages: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/project-stages?${params.toString()}`);
  },

  getProjectStageById: (projectStageId) => api.get(`/project-stages/${projectStageId}`),

  updateProjectStage: (projectStageId, projectStageData) => api.patch(`/project-stages/${projectStageId}`, projectStageData),

  deleteProjectStage: (projectStageId) => api.delete(`/project-stages/${projectStageId}`),

  // Document management
  getDocuments: (projectId, filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/projects/${projectId}/documents?${params.toString()}`);
  },

  uploadDocument: (projectId, formData) =>
    api.post(`/projects/${projectId}/documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  deleteDocument: (projectId, fileId) => api.delete(`/projects/${projectId}/documents/${fileId}`),
};
